// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message_wrapper__AimpZ {
  width: 100%;
  height: 100%; }

.message_container__rjn1F {
  width: 100%;
  height: calc(100vh - 228px);
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);
  border-radius: 4px;
  margin-bottom: 10px;
  overflow: auto; }

.message_item__JJw5r {
  padding: 10px 20px 10px 40px;
  border: 1px solid #e0e0e0; }
  .message_item__head__mjD4d {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px; }
    .message_item__head__mjD4d h5 {
      font-weight: 600;
      font-size: 14px;
      line-height: 150%; }
    .message_item__head__mjD4d time {
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      color: #666666; }
  .message_item__content__zGOjE {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #666666; }

.message_empty__mIL\\+N {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 11px; }
  .message_empty__mIL\\+N h1 {
    font-weight: 700;
    font-size: 18px;
    line-height: 150%; }
  .message_empty__mIL\\+N p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #666666; }

.message_footer__XvfOH {
  width: 100%;
  padding: 22px 20px;
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);
  border-radius: 4px; }
  .message_footer__XvfOH .message_left__hWE7r {
    transform: rotate(180deg);
    cursor: pointer; }
    .message_footer__XvfOH .message_left__hWE7r:hover {
      transform: rotate(180deg), scale(1.1); }
  .message_footer__XvfOH .message_right__GUYEL {
    cursor: pointer; }
    .message_footer__XvfOH .message_right__GUYEL:hover {
      transform: scale(1.1); }
  .message_footer__XvfOH .message_disable__AheKZ {
    opacity: 0.3;
    cursor: default;
    pointer-events: none; }
  .message_footer__XvfOH .message_page__oA11S {
    margin: 0 15px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    cursor: default; }
`, "",{"version":3,"sources":["webpack://./src/pages/info/messages/message.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY,EAAA;;AAEd;EACE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,cAAc,EAAA;;AAEhB;EACE,4BAA4B;EAC5B,yBAAyB,EAAA;EACzB;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB,EAAA;IAHnB;MAKG,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IAPpB;MAUG,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc,EAAA;EAGlB;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAA;;AAGlB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS,EAAA;EAPX;IASI,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAXrB;IAcI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAA;;AAGlB;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB,EAAA;EALpB;IAOI,yBAAyB;IACzB,eAAe,EAAA;IARnB;MAUM,qCAAqC,EAAA;EAV3C;IAcI,eAAe,EAAA;IAdnB;MAgBM,qBAAqB,EAAA;EAhB3B;IAoBI,YAAY;IACZ,eAAe;IACf,oBAAoB,EAAA;EAtBxB;IAyBI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe,EAAA","sourcesContent":[".wrapper {\n  width: 100%;\n  height: 100%;\n}\n.container {\n  width: 100%;\n  height: calc(100vh - 228px);\n  background: #ffffff;\n  box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);\n  border-radius: 4px;\n  margin-bottom: 10px;\n  overflow: auto;\n}\n.item {\n  padding: 10px 20px 10px 40px;\n  border: 1px solid #e0e0e0;\n  &__head {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 5px;\n    h5 {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 150%;\n    }\n    time {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 150%;\n      color: #666666;\n    }\n  }\n  &__content {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: #666666;\n  }\n}\n.empty {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 11px;\n  h1 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 150%;\n  }\n  p {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #666666;\n  }\n}\n.footer {\n  width: 100%;\n  padding: 22px 20px;\n  background: #ffffff;\n  box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);\n  border-radius: 4px;\n  .left {\n    transform: rotate(180deg);\n    cursor: pointer;\n    &:hover {\n      transform: rotate(180deg), scale(1.1);\n    }\n  }\n  .right {\n    cursor: pointer;\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n  .disable {\n    opacity: 0.3;\n    cursor: default;\n    pointer-events: none;\n  }\n  .page {\n    margin: 0 15px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `message_wrapper__AimpZ`,
	"container": `message_container__rjn1F`,
	"item": `message_item__JJw5r`,
	"item__head": `message_item__head__mjD4d`,
	"item__content": `message_item__content__zGOjE`,
	"empty": `message_empty__mIL+N`,
	"footer": `message_footer__XvfOH`,
	"left": `message_left__hWE7r`,
	"right": `message_right__GUYEL`,
	"disable": `message_disable__AheKZ`,
	"page": `message_page__oA11S`
};
export default ___CSS_LOADER_EXPORT___;
